import { getToken } from "./authServiceCookie";

export default function UserToken() {
  const token = getToken();
  return token;
}
